module.exports = __webpack_public_path__ + "img/phone.d8ed5ecf.svg";